module.exports = __webpack_public_path__ + "media/native-apps/huddinge-3f07ffec.webp";